module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0055.jpg?v=1965cb0a";